// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tkjekphvwwzmhfoondwr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRramVrcGh2d3d6bWhmb29uZHdyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ5OTg3ODQsImV4cCI6MjA2MDU3NDc4NH0.jEriMkmNjqaqMKkWtrsrf6n4ujHuMJfUDiexUnHsTZI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    flowType: 'pkce',
    detectSessionInUrl: true,
  },
  // Enhanced security headers
  global: {
    headers: {
      'X-Client-Info': 'sclepios-web-app'
    }
  }
});